import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {IMAGE_MAP, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
const styles = require('./style.module.less')
interface TenErrorProps{
  title?:string
}
const TenError = (props: TenErrorProps) => {
    const {title = '加载失败了'} = props
    return (
        <div className={classNames(styles.bg)}>
            <TitleBar
                backgroundColor='transparent'
                content={TenAcTitle}
                hasOccupy
            />
            <div className='fc jcenter f1 pl40 pr40 pb200'>
                <I
                    src='https://i.gsxcdn.com/2401634164_ikt8gwe6.png'
                    width={140}
                    height={124}
                >
                </I>
                <span className='fs16 fw400 lh24 #000 mt16'>{ title}</span>
            </div>
        </div>
    )
}

export default TenError
